// extracted by mini-css-extract-plugin
export default {"privacyDescription":"privacy_section-module___privacyDescription___fe5659a2"};